import React, { useState } from 'react';
import '../styles/subscriptions.css';

const CheckIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M5 12l4 4 10-10" />
  </svg>
);

const FireIcon = () => (
  <svg className="subscriptions-fire-icon" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2c1 4 4 5.5 4 9a4 4 0 11-8 0c0-3.5 3-5 4-9z" />
  </svg>
);

const basicFeatures = [
  {
    title: 'Acceso limitado a proveedores',
    text: 'Solo puedes ver información de proveedores Premium.',
  },
  {
    title: 'Información Restringida',
    text: 'Precios de servicios aparecen difuminados.',
  },
  {
    title: 'Sin Uso de Cupones',
    text: 'Puedes ver las promociones disponibles, pero no puedes redimir cupones de descuento.',
  },
  {
    title: 'Limitado en Eventos y Actividades',
    text: 'No tienes acceso al calendario completo de eventos.',
  },
  {
    title: 'Notificaciones Restrictivas',
    text: 'Las demás notificaciones quedan bloqueadas hasta suscribirte al plan Premium.',
  },
];

const premiumFeatures = [
  {
    title: 'Acceso Ilimitado a Información Completa',
    text: 'Visualiza todos los detalles de proveedores, incluyendo precios y contactos.',
  },
  {
    title: 'Acceso Completo al Calendario de Eventos',
    text: 'Visualiza todas las actividades y eventos del mes, incluyendo fines de semana completos.',
  },
  {
    title: 'Soporte al Cliente Preferencial',
    text: 'Atención dedicada para resolver cualquier duda o inconveniente.',
  },
];

const SubscriptionsPage = () => {
  const [billingCycle, setBillingCycle] = useState('mensual');

  return (
    <div className="subscriptions-root">
      <section className="subscriptions-section subscriptions-section-plans">
        <div className="subscriptions-plans-panel">
          <header className="subscriptions-plans-header">
            <h1 className="subscriptions-plans-title">¡Elige el plan que se ajuste a ti!</h1>
            <p className="subscriptions-plans-subtitle">
              Selecciona el plan que se ajuste a tus necesidades y comienza a disfrutar de una experiencia
              personalizada y única
            </p>
          </header>

          <div className="subscriptions-billing-toggle" role="tablist" aria-label="Tipo de facturación">
            <button
              type="button"
              role="tab"
              aria-selected={billingCycle === 'mensual'}
              className={`subscriptions-billing-option${
                billingCycle === 'mensual' ? ' subscriptions-billing-option--active' : ''
              }`}
              onClick={() => setBillingCycle('mensual')}
            >
              <span>Mensual</span>
              <span className="subscriptions-billing-badge subscriptions-billing-badge--discount">
                <FireIcon />
                50% de descuento
              </span>
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={billingCycle === 'anual'}
              className={`subscriptions-billing-option${
                billingCycle === 'anual' ? ' subscriptions-billing-option--active-navy' : ''
              }`}
              onClick={() => setBillingCycle('anual')}
            >
              <span>Anual</span>
              <span className="subscriptions-billing-badge subscriptions-billing-badge--recommended">
                <FireIcon />
                Plan Recomendado
              </span>
            </button>
          </div>

          <div className="subscriptions-plans-grid">
            <article className="subscriptions-plan-card subscriptions-plan-card--basic">
              <div className="subscriptions-plan-top">
                <h2 className="subscriptions-plan-name">Básico</h2>
                <span className="subscriptions-plan-badge subscriptions-plan-badge--current">
                  <CheckIcon className="subscriptions-plan-badge-icon" />
                  Plan actual
                </span>
              </div>

              <div className="subscriptions-plan-pricing">
                <p className="subscriptions-plan-price">Gratis</p>
                <p className="subscriptions-plan-saving">Ahorra 80% al año</p>
              </div>

              <ul className="subscriptions-plan-features">
                {basicFeatures.map((feature) => (
                  <li key={feature.title} className="subscriptions-plan-feature">
                    <CheckIcon className="subscriptions-plan-feature-icon subscriptions-plan-feature-icon--basic" />
                    <div>
                      <p className="subscriptions-plan-feature-title">{feature.title}</p>
                      <p className="subscriptions-plan-feature-text">{feature.text}</p>
                    </div>
                  </li>
                ))}
              </ul>

              <p className="subscriptions-plan-footer">Renovación automática, cancela en cualquier momento</p>
            </article>

            <article className="subscriptions-plan-card subscriptions-plan-card--premium">
              <div className="subscriptions-plan-banner">
                <FireIcon />
                50% de Descuento
              </div>

              <div className="subscriptions-plan-content">
                <h2 className="subscriptions-plan-name">Premium</h2>

                <div className="subscriptions-plan-pricing subscriptions-plan-pricing--premium">
                  <p className="subscriptions-plan-price">
                    {billingCycle === 'mensual' ? '$1,49' : '$14,99'}
                    <span className="subscriptions-plan-price-period">
                      / {billingCycle === 'mensual' ? 'mensual' : 'anual'}
                    </span>
                  </p>
                  <span className="subscriptions-plan-price-old">
                    Antes {billingCycle === 'mensual' ? '$2,98' : '$29,98'}
                  </span>
                </div>

                <ul className="subscriptions-plan-features">
                  {premiumFeatures.map((feature) => (
                    <li key={feature.title} className="subscriptions-plan-feature">
                      <CheckIcon className="subscriptions-plan-feature-icon subscriptions-plan-feature-icon--orange" />
                      <div>
                        <p className="subscriptions-plan-feature-title">{feature.title}</p>
                        <p className="subscriptions-plan-feature-text">{feature.text}</p>
                      </div>
                    </li>
                  ))}
                </ul>

                <button type="button" className="subscriptions-plan-cta">
                  Suscribirse al plan Premium
                </button>

                <p className="subscriptions-plan-footer">Renovación automática, cancela en cualquier momento</p>
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SubscriptionsPage;
